<template>
	<Modals
		:title="'Codes'"
		:validateBeforeClose="validateBeforeClose"
		:display="display"
		@show="closeCodeManagerCodesModal"
		:parentTag="'form'"
		:novalidate="'novalidate'"
		:fullMobile="true"
	>
		<template #modal-content>
			<div class="code-list-search">
				<div class="results-toolbar results-toolbar--variant-one">
					<div class="code-list-search__selection">
						<Search
							:placeholder="placeholder"
							v-model="dataSearch"
						/>
					</div>
					<div class="results-toolbar__counter">
						<ResultCounter
							:counter="resultCounter"
							v-if="hasResults"
						/>
					</div>
				</div>
				<CodesModalList
					:source="pagingModel"
					v-model="scrollLock"
					ref="codelist"
				/>
			</div>
		</template>
		<template #modal-footer>
			<Button
				className="btn--primary"
				labelText="Close"
				:btnClick="closeCodeManagerCodesModal"
			/>
		</template>
	</Modals>
</template>

<script>
import Modals from '@/components/shells/modal/modals';
import Search from '@/components/forms/search/search';
import Button from '@/components/forms/button/button';
import { mapActions } from 'vuex';
import PaginationPage from '@/mixins/infiniteScroll/page';
import CodesModalList from '@/views/code-manager/code-list-modal-list.vue';
import ResultCounter from '@/site-components/result-counter/result-counter';
import _ from 'lodash';

export default {
	name: 'CodeManagerCodesModal',
	mixins: [PaginationPage],
	components: {
		Modals,
		Search,
		Button,
		CodesModalList,
		ResultCounter
	},
	model: {
		prop: 'display',
		event: 'show'
	},
	props: {
		title: {
			type: String,
			default: ''
		},
		placeholder: {
			type: String,
			default: 'Search codes'
		},
		parentTag: {
			type: String,
			default: 'div'
		},
		validateBeforeClose: {
			type: Boolean,
			default: false
		},
		display: {
			type: Boolean,
			default: false
		},
		search: {
			default: ''
		},
		pageProp: {
			type: Number,
			default: 1
		}
	},
	data() {
		return {
			privilegedUser: true,
			dataSearch: this.search,
			codeManager: {}
		};
	},
	computed: {
		isConfirmation() {
			return this.type == 'confirmation';
		},
		codeManagerList() {
			return this.codeManager.items;
		}
	},
	methods: {
		...mapActions('codemanager', ['loadCodeManager']),

		closeCodeManagerCodesModal() {
			if (!this.validateBeforeClose) {
				this.$emit('show', false);
			}
		},
		async fetchData(page) {
			let query = {
				search: this.dataSearch,
				page: page,
				count: 100
			};
			await this.loadCodeManager(query).then(res => {
				this.codeManager = _.cloneDeep(res);
				this.parseResponse(res);
			});
		},
		parseResponse(data) {
			this.setPagingData(data, data.page === 1);
		}
	},
	watch: {
		display: {
			async handler(val) {
				this.$store.commit('codemanager/SetShowModal', val);
				if (val) {
					if (_.get(this, 'codeManager.items.length', 0) === 0) {
						await this.fetchData(1);
					}
					this.pagingModel = { ...this.codeManager };
					this.dataSearch = this.search;
					if (this.pageProp > 1) {
						this.page = this.pageProp;
					}
				}
			}
		},
		dataSearch: {
			handler() {
				this.fetchData(1);
			}
		},
		page: {
			handler(page) {
				this.fetchData(page);
			}
		}
	}
};
</script>

<style lang="scss" scoped>
/**
    * [Description]
    * Code Manager Codes Modal
*/
::v-deep .results-toolbar .results-toolbar__search {
	@include mq($from: md) {
		width: 347px;
	}
}

.code-list-search {
	@include mq($from: md) {
		width: 360px;
	}
	&__selection {
		flex-wrap: wrap;
		margin-bottom: $gutter-lg;
		display: flex;
		flex-direction: column;
		overflow: hidden;
	}
}
</style>
